export const iconFontAwesomeMediaplaybackPlusMinus = (
	<i className="fa-solid fa-plus-minus"></i>
);
